// extracted by mini-css-extract-plugin
export var breadcrumb = "_16-2";
export var breadcrumbArrow = "_16-3";
export var breadcrumbs = "_16-0";
export var link = "_16-4";
export var small = "_16-1";